import { type PrimaryCategoryConstructor } from '@webapp/core/entities/internal/PrimaryCategory'
import { mapLegalEntitySummary } from './mapLegalEntitySummary'
import { type LocationApiModel } from '../api-models/LocationApiModel'

export const mapLocation = (
  location: LocationApiModel
): PrimaryCategoryConstructor => ({
  id: location.id,
  name: location.name,
  ...(location.legal_entity
    ? { legalEntity: mapLegalEntitySummary(location.legal_entity) }
    : {}),
})
